(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    // Prüfe, ob Slider vorhanden sind
    const donateSliders = document.querySelectorAll('.paragraph--type--donate-slider');

    if (donateSliders.length > 0) {
      donateSliders.forEach(initDonateSlider);
    }

    function initDonateSlider(slider) {
      // Elemente auswählen
      const rangeAmount = slider.querySelector('#range_amount');
      const scalaVals = slider.querySelectorAll('.scala_val');
      const textAmount = slider.querySelector('.text_amount');
      const draggableDonate = slider.querySelector('.draggable_donate');
      const rangeOuter = slider.querySelector('.range_outer');

      // Schrittweiten definieren
      const steps = [...slider.querySelectorAll('[class*="step_"]')].map(step => parseInt(step.dataset.value));

      // Klick- und Touch-Handler für vordefinierte Beträge
      scalaVals.forEach(scala => {
        scala.addEventListener('click', () => setPresetAmount(scala));
      });

      // Eingabe-Handler für das Eingabefeld
      rangeAmount.addEventListener('input', updateFromInput);

      // Initialisiere die interaktive Resize-Funktion
      initResizable(draggableDonate, rangeOuter, steps, rangeAmount, textAmount);

      // Funktionen

      function setPresetAmount(element) {
        const value = element.dataset.value;
        rangeAmount.value = value;
        textAmount.textContent = `${value} €`;
        updateSliderWidth(draggableDonate, element.style.left);
      }

      function updateFromInput() {
        const value = rangeAmount.value.trim();
        if (value !== '') {
          textAmount.textContent = `${value} €`;
        }
      }

      function initResizable(draggable, outer, stepValues, inputEl, displayEl) {
        interact(draggable)
          .resizable({
            edges: { left: false, right: true, bottom: false, top: false },
            restrictEdges: {
              outer: 'parent',
              endOnly: false
            },
            restrictSize: {
              min: { width: 0 }
            },
            inertia: false
          })
          .on('resizemove', event => resizeHandler(event, outer, stepValues, inputEl, displayEl));
      }

      function resizeHandler(event, outer, stepValues, inputEl, displayEl) {
        const target = event.target;
        const outerWidth = outer.offsetWidth;
        const newWidthPercent = (event.rect.width / outerWidth) * 100;

        let coefficient = calculateCoefficient(newWidthPercent, stepValues);
        let amount = Math.round(newWidthPercent * coefficient);

        // Betragsgrenzen einhalten
        if (amount < stepValues[0]) {
          amount = stepValues[0];
        }

        // Aktualisiere den Betrag
        inputEl.value = amount;
        displayEl.textContent = `${amount} €`;

        // Setze die Breite des draggable Elements
        target.style.width = event.rect.width + 'px';
        target.setAttribute('data-x', amount);
      }

      function calculateCoefficient(percent, steps) {
        if (percent <= 20) return steps[1] / 20;
        if (percent <= 40) return steps[2] / 40;
        if (percent <= 60) return steps[3] / 60;
        if (percent <= 80) return steps[4] / 80;
        return steps[5] / 100;
      }

      function updateSliderWidth(slider, leftPosition) {
        slider.style.width = leftPosition || '0px';
      }
    }
  });
})();
